<template lang="pug">
.neodiko
  svg(xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 99.8 21.6").block
    defs
      linearGradient(id="gradient-base" x1="3.59" y1="3.62" x2="17.98" y2="18.01" gradientUnits="userSpaceOnUse")
        stop(offset="0" stop-color="currentColor")
        stop(offset="1" stop-color="currentColor")
      linearGradient(id="gradient-accent" x1="39.16" y1="3.65" x2="43.84" y2="8.33" xlink:href="#gradient-base")
    title Neodiko
    path(class="cls-1" d="M21.57,10.81,14.36,21.63,9.56,0h2.49L15.5,15.53l3.15-4.72L14.87,5.15h2.92ZM0,10.81l3.78,5.67H6.7L2.93,10.81,6.07,6.1,9.52,21.63H12L7.21,0Z")
    g
      path(class="cls-2" d="M27.55,9.72v6.92h-2V4.82L32.76,12V5h2V16.9Z")
      rect(class="cls-3" x="37.82" y="4.99" width="7.36" height="2")
      path(class="cls-2" d="M37.82,9.81h6v2h-4v2.84h5.36v2H37.82V9.81")
      path(class="cls-2" d="M53.12,16.74A5.69,5.69,0,0,1,50.18,16a6,6,0,0,1-3-5.14,5.8,5.8,0,0,1,.8-3,5.86,5.86,0,0,1,2.15-2.16,5.88,5.88,0,0,1,5.89,0,5.94,5.94,0,0,1,2.15,2.16,5.93,5.93,0,0,1,0,5.95A5.94,5.94,0,0,1,56.07,16,5.72,5.72,0,0,1,53.12,16.74Zm0-9.87a3.78,3.78,0,0,0-1.95.53,3.85,3.85,0,0,0-1.42,1.44,4,4,0,0,0,0,3.95,3.85,3.85,0,0,0,1.42,1.44,3.87,3.87,0,0,0,3.91,0,4,4,0,0,0,1.41-5.4A3.87,3.87,0,0,0,55.08,7.4,3.82,3.82,0,0,0,53.12,6.87Z")
      path(class="cls-2" d="M65,16.64H61.35V5H65a5.89,5.89,0,0,1,2.29.46,5.3,5.3,0,0,1,1.85,1.33,5.43,5.43,0,0,1,1.1,1.84,6.47,6.47,0,0,1,0,4.37,5.62,5.62,0,0,1-1.1,1.86,5.3,5.3,0,0,1-1.85,1.33A5.89,5.89,0,0,1,65,16.64Zm-1.67-2H65a3.57,3.57,0,0,0,1.47-.29,3.19,3.19,0,0,0,1.18-.84,3.75,3.75,0,0,0,.74-1.24,4.3,4.3,0,0,0,.25-1.48,4.19,4.19,0,0,0-.25-1.46,3.81,3.81,0,0,0-.74-1.23A3.32,3.32,0,0,0,65,7H63.33Z")
      path(class="cls-2" d="M73.24,16.64V5h2V16.64Z")
      path(class="cls-2" d="M87.43,16.64H85l-3.16-4.32L78.52,16.9V5h2v5.7L84.6,5H87L83,10.6Z")
      path(class="cls-2" d="M94,16.74A5.7,5.7,0,0,1,91,16a5.94,5.94,0,0,1-2.15-2.16,5.93,5.93,0,0,1,0-5.95A5.94,5.94,0,0,1,91,5.68a5.88,5.88,0,0,1,5.89,0A5.94,5.94,0,0,1,99,7.84a5.93,5.93,0,0,1,0,5.95A5.94,5.94,0,0,1,96.89,16,5.69,5.69,0,0,1,94,16.74Zm0-9.87a3.88,3.88,0,0,0-3.38,2,4,4,0,0,0,0,3.95,3.88,3.88,0,0,0,3.38,2,3.78,3.78,0,0,0,2-.53,3.9,3.9,0,0,0,1.42-1.43,4,4,0,0,0,0-4A3.9,3.9,0,0,0,95.9,7.4,3.78,3.78,0,0,0,94,6.87Z")
  span.off_screen Neodiko, experiencias únicas para la web
</template>

<script>
export default {
  name: 'LogoNeodiko',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.neodiko svg
  fill currentColor
  linearGradient stop
    transition .3s ease
  .cls-1
    fill url(#gradient-base)
  .cls-2
    transition fill .3s ease
  .cls-3
    fill url(#gradient-accent)
  &:hover
    linearGradient stop
      &:first-child
        stop-color #3545ee
      &:last-child
        stop-color #6200ea
    .cls-2
      fill #ffffff
</style>